<template>
  <div
    class="box-border flex min-w-[300px] items-center justify-between bg-gray-900"
    :class="{
      '!pb-4 !pt-3': !title,
      'px-5 pb-3 pt-2': !isInUtility,
    }"
  >
    <div v-if="title" class="flex items-center gap-3">
      <p class="font-inter text-sm font-medium leading-8 text-gray-200">
        {{ title }}
      </p>
      <TButton v-if="canRenameTemplate" sm @click="renameTemplate">
        <template #icon>
          <Pen />
        </template>
      </TButton>
    </div>
    <div
      v-if="activeMembers.length > 0"
      v-tooltip="{ content: tooltipContent, html: true }"
      class="flex items-center gap-2 rounded-md bg-gray-700 py-0.5 pl-1.5 pr-1"
    >
      <div class="h-2 w-2 rounded-full bg-accent-2"></div>
      <div
        class="leading-1 flex items-center font-inter text-xs font-medium text-gray-100"
      >
        {{ activeMembers.length }}
        <div class="inline-grid h-5 w-5 items-center justify-center">
          <font-awesome-icon :icon="['fas', 'user']" />
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
  import { useActiveMembersStore } from "@/stores/activeMembers";
  import { useGeneralStore } from "@/stores/generalStore";
  import { Pen } from "@topol/icons";
  import { TButton } from "@topol/twig-ui";
  import { computed } from "vue";

  defineProps({
    isInUtility: {
      type: Boolean,
      default: false,
    },
  });

  const activeMembersStore = useActiveMembersStore();
  const generalStore = useGeneralStore();

  const title = computed(() => {
    return generalStore.title;
  });

  const canRenameTemplate = computed(() => {
    return generalStore.renameTemplate;
  });

  const activeMembers = computed(() => {
    return activeMembersStore.activeMembers;
  });

  const tooltipContent = computed(() => {
    const thisActiveMembers = activeMembers.value;
    return thisActiveMembers.join("<br>");
  });

  function renameTemplate() {
    const message = {
      type: "callback",
      action: "onTemplateRename",
      data: {
        args: [title.value],
      },
    };

    window.parent.postMessage(JSON.parse(JSON.stringify(message)), "*");
  }
</script>
<style lang="scss">
  // @import "./MenuHeader.scss";
</style>
